'use strict';

module.exports = '2.24.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 385
// module chunks = 142807904292071